<template>
	<div id="app">
		<div
			style="position: fixed;top: 0; z-index: 999; background-color: red;width: 100%;height: 15px;line-height: 15px; text-align: center;font-size: 12px;color: white;font-weight: 600;">
			推荐使用谷歌双核浏览器</div>
		<!-- 客服 首页头部 -->
		<div>

			<!-- 页面头部 -->
			<div class=""
				style="height: 70px;position: fixed;z-index: 999;top:15px;right: 0;width: 100%;border: 0;left: 0;background-color: #fff;">
				<div>
					<ul class="nav	w-1200">
						<a href="/"
							style="position: absolute;left: 50px; font-weight: bold;font-size: 30px;color:black;">
							<img style="width:60px;height: 60px;line-height: 70px;" src="../../static/img/logo.png">
							职业技能等级认定考试
						</a>
					</ul>
				</div>
			</div>
		</div>
		<div class="column pagestyle___3At3P">
			<div class="row">
				<div style="width: 630px; margin-right: 9%;float: left"></div>
				<div class="ant-form ant-form-horizontal"
					style="position: relative;top: 50px;width: 430px; background: rgb(255, 255, 255); border-radius: 20px; padding: 60px 40px; box-shadow: rgba(235, 235, 235, 0.54) 0px 6px 10px 1px;">
					<div class="row" style="margin-bottom: 20px;">
						<h2 style="font-size: 18px; color: rgb(21, 21, 21); margin: 0px; flex: 1 1 0%;">欢迎登录</h2>
					</div>
					<div class="ant-row ant-form-item">
						<div class="ant-col ant-form-item-control-wrapper">
							<div class="ant-form-item-control">
								<span class="ant-form-item-children">
									<span class="ant-input-affix-wrapper" style="height: 40px;">
										<span class="ant-input-prefix">
											<i class="layui-icon layui-icon-username"></i>
										</span>
										<input placeholder="请输入身份证号" type="text" id="idCard" class="ant-input"
											v-model="idCard">
									</span>
								</span>
							</div>
						</div>
					</div>
					<div class="ant-row ant-form-item" style="margin-bottom: 5px;">
						<div class="ant-col ant-form-item-control-wrapper">
							<div class="ant-form-item-control">
								<span class="ant-form-item-children">
									<span class="ant-input-password ant-input-affix-wrapper" style="height: 40px;">
										<span class="ant-input-prefix">
											<i class="layui-icon layui-icon-password"></i>
										</span>
										<input type="password" placeholder="请输入登录密码" id="password" v-model="password"
											class="ant-input" @keyup.enter="immediatelyLogin">
									</span>
								</span>
							</div>
						</div>
					</div>
					<div class="ant-row ant-form-item">
						<div class="ant-col ant-form-item-control-wrapper">
							<div class="ant-form-item-control">
								<div @click="immediatelyLogin" type="button" id="submit"
									class="ant-btn login-form-button ant-btn-primary" style="width: 100%; height: 40px;background: rgb(55, 151, 240);
                                border-radius: 0;line-height: 40px;font-size: 17px;">
									<span>立即登录</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<end style="position: relative;top:0px;"></end>
	</div>
</template>
<script>
	//import homePage from './components/homePage.vue';
	import End from './end.vue';
	export default {
		name: 'app',
		components: {
			End
		},
		data() {
			return {
				gzhFlag: false,
				declareUser: {},
				idCard: '',
				password: ''

			}
		},
		watch: {
			'$route': function (to, from) {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
			}
		},
		methods: {
			onSuccess() {

				const loading = this.$loading({
					lock: true,
					text: '登陆中，请稍后...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});

				let _this = this;
				let parames = new URLSearchParams();
				parames.append('idCard', this.idCard);
				parames.append('password', this.password);

				this.$axios.post(this.serverUrl + '/login', parames).then(resp => {

					if (resp.data.code === 1) {
						loading.close();
						this.$message({
							message: '登录成功',
							offset: 100,
							type: 'success',
							duration: 1500
						});
						setTimeout(() => {
							_this.$storage.set('token', resp.data.token);
							_this.$storage.set('declareUser', resp.data.data);
							let parames = new URLSearchParams();
							parames.append('userId', resp.data.data.id);
							let ArrayList = [];
							this.$axios.post(this.serverUrl + '/ex/examList', parames).then(resp1 => {
								loading.close();
								this.dialogVisible = false;

								//能进来此接口就一定有考试信息 直接循环获取
								if (resp1.data.data.length > 0) {

									//技能考试
									this.$router.push({ path: '/examHomePage' });

								} else {
									this.$message({
										showClose: true,
										message: '暂无考试！',
										type: 'warning',
										offset: 300,
										center: true

									})
								}
							}).catch(err => {

							})


						}, 1500);




					} else {

						this.$message({
							message: resp.data.msg,
							offset: 250,
							type: 'warning',
							duration: 1500
						});
					}
				}).catch(err => {
					this.$message({
						message: '服务器繁忙！',
						type: 'warning'
					});
				})

			},
			immediatelyLogin() {
				if (this.idCard === '') {
					this.$message({
						message: '请填写身份证号！',
						type: 'warning'
					});
					return false;
				} else if (this.password === '') {
					this.$message({
						message: '请填写密码！',
						type: 'warning'
					});
					return false;
				}
				this.onSuccess();
			},
		}
	}
</script>

<style src="../../static/css/login.css" scoped></style>

<style scoped>
	.el-dialog__body {
		padding: 15px 30px;
		color: #606266;
		font-size: 14px;
		word-break: break-all;
	}

	.el-dialog {
		position: absolute;
		/* margin: 0 auto 50px; */
		right: 16%;
		top: 15%;
		border-radius: 2px;
		-webkit-box-shadow: 0 1px 3px rgb(0 0 0 / 30%);
		box-shadow: 0 1px 3px rgb(0 0 0 / 30%);
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		width: 50%;
	}

	.pagestyle___3At3P {
		background-size: cover;
		position: relative;
		height: 600px;
	}

	#floatDivBoxs {
		width: 120px;
		background: #fff;
		position: fixed;
		top: 180px;
		right: -125px;
		z-index: 999;
	}

	#floatDivBoxs .floatDqq li {
		height: 45px;
		line-height: 45px;
		font-size: 15px;
		border-bottom: 1px solid #e3e3e3;
		padding: 0 0 0 36px;
		background: url(../../static/img/qq.gif) no-repeat left center;
	}

	#adbox {
		width: 500px;
		height: auto;
		background-color: #7ac5ff;
		position: absolute;
		z-index: 999;
		color: white;
		padding: 20px;
		font-size: 15px;

	}

	#adbox img {
		border: none;
	}

	#adbox b {
		position: absolute;
		right: 5px;
		top: 0;
		cursor: pointer;
		color: #666;
	}

















	.floatDbg {
		width: 120px;
		height: 20px;
		background: url(../../static/f/img/online_botbg.jpg) no-repeat;
	}

	.floatDtt {
		width: 120px;
		height: 45px;
		line-height: 45px;
		background: #00aeef;
		color: #fff;
		font-size: 18px;
		text-indent: 22px;
		position: relative;
	}

	#rightArrow {
		right: 120px;
		width: 50px;
		height: 145px;
		background: url(../../static/f/img/online_arrow.jpg) no-repeat;
		position: fixed;
		top: 180px;
		right: -5px;
		z-index: 9999;

	}

	#floatDivBoxs {
		right: 0px;
		width: 120px;
		background: #fff;
		position: fixed;
		top: 180px;
		right: -125px;
		z-index: 999;
	}


	.animationLeftMove {
		animation: rotation 0.5s linear;
	}

	@keyframes rotation {
		from {
			transform: rotate(0deg);
		}

		to {
			transform: rotate(180deg);
		}
	}

	.animationLeftExpose {
		animation: moveLeftExpose 0.3s linear;
		animation-iteration-count: 1;
		animation-fill-mode: forwards;
	}

	.animationRightExpose {
		animation: moveRightExpose 0.3s linear;
		animation-iteration-count: 1;
		animation-fill-mode: forwards;

	}

	@keyframes moveLeftExpose {
		from {
			right: 0px;
		}

		to {
			right: 120px;
		}
	}

	@keyframes moveRightExpose {
		from {
			right: 120px;
		}

		to {
			right: 0px;
		}
	}

	.animationLeft {
		animation: moveLeft 0.3s linear;
		animation-iteration-count: 1;
		animation-fill-mode: forwards;
	}

	.animationRight {
		animation: moveRight 0.3s linear;
		animation-iteration-count: 1;
		animation-fill-mode: forwards;
	}

	@keyframes moveLeft {
		from {
			right: -120px;
		}

		to {
			right: 0px;
		}
	}

	@keyframes moveRight {
		from {
			right: 0px;
		}

		to {
			right: -120px;
		}
	}

	.a {
		position: absolute;
		left: 0;
		top: 65px;
		min-width: 100%;
		line-height: 36px;
		padding: 5px 0;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12);
		border: 1px solid #d2d2d2;
		background-color: #fff;
		z-index: 100;
		border-radius: 2px;
		white-space: nowrap;
	}

	.bd {
		margin: 0 auto;
		width: 100% !important;
		position: relative;
		z-index: 0;
	}

	.mian {
		min-width: 1200px;
		padding-top: 15px;
	}

	.page_box {
		width: 100%;
		height: auto;
		overflow: hidden;
		margin: 0 auto;
		clear: both;
	}

	.page_box_right {
		width: 1200px;
		height: auto;
		overflow: hidden;
		margin: 0 auto;
	}

	#fitslist {
		padding: 0 15px;
		min-height: 400px;
	}

	#fitslist .index_6_2_1_4 {
		width: 100%;
		height: 110px;
		padding-bottom: 25px;
		border-bottom: #eeeeee solid 1px;
		margin-top: 15px;
		float: left;
	}

	#fitslist .index_6_2_1_4_2 {
		width: 980px;
		height: 110px;
		padding: 0 15px;
		float: left;
		line-height: 110px;
	}

	.clearfix {
		display: block;
		clear: both;
	}
</style>


// WEBPACK FOOTER //
// src/components/examLogin.vue